import dayjs from "dayjs";
import { Setting, VatInvoice } from "lib/models";
import React from "react";

const VatPaper = ({
  vatInvoice,
  setting,
}: {
  vatInvoice: VatInvoice | undefined;
  setting: Setting;
}) => {
  if (!vatInvoice) {
    return null;
  }

  return (
    <div className="flex items-center justify-center overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0">
      <div className="border-2 border-solid border-gray-400 bg-white w-full min-w-[720px] max-w-4xl">
        <div className="flex justify-between items-center bg-blue-50">
          <div
            className="text-xl text-center font-bold text-gray-600 h-10 w-[50%] pt-1 
          border-b-[3px] border-b-red-300 border-solid border-r-2 border-r-gray-300"
          >
            전자세금계산서
          </div>
          <div className="w-[50%] h-10 border-b-[3px] border-solid border-blue-300">
            <div className="w-[20%] h-full text-center text-gray-700 pt-2 border-r-2 border-solid border-gray-300">
              승인번호
            </div>
            <div className="w-[42%]"></div>
          </div>
        </div>
        <div className="grid grid-cols-2 border-b-2 border-gray-400 text-sm">
          <div className="border-solid border-gray-300 grid grid-cols-[30px_1fr] items-stretch border-b-2 border-b-gray-400 border-r-2 border-r-gray-40">
            <div className="text-center font-bold text-red-600 bg-red-200 px-2 flex items-center">
              <div>공급자</div>
            </div>
            <div className="text-center">
              <div className="grid grid-cols-[60px_1fr_60px_60px] border-b border-solid border-red-300 box-border items-center">
                <div className="border-r border-solid border-red-300 px-1 whitespace-pre-wrap">
                  등록{"\n"}번호
                </div>
                <div className="border-r border-solid border-red-300 px-1 h-full flex justify-center items-center">
                  <div>{setting.businessNo}</div>
                </div>
                <div className="border-r border-solid border-red-300 px-1">
                  종사업장 번호
                </div>
                <div></div>
              </div>
              <div className="grid grid-cols-[60px_1fr_60px_60px] border-b border-solid border-red-300 box-border items-center">
                <div className="border-r border-solid border-red-300 px-1 whitespace-pre-wrap">
                  상호{"\n"}(법인명)
                </div>
                <div className="border-r border-solid border-red-300 px-1 h-full flex justify-center items-center">
                  <div>{setting.companyName}</div>
                </div>
                <div className="border-r border-solid border-red-300 px-1 h-full flex justify-center items-center">
                  <div>성명</div>
                </div>
                <div>{setting.ceoName}</div>
              </div>
              <div className="grid grid-cols-[60px_1fr] border-b border-solid border-red-300 box-border items-center h-8">
                <div className="border-r border-solid border-red-300 px-1 whitespace-pre-wrap h-8 flex justify-center items-center">
                  <div>사업장</div>
                </div>
                <div className="px-1 h-full flex justify-start items-center pl-3">
                  <div>{setting.address}</div>
                </div>
              </div>
              <div className="grid grid-cols-[60px_1fr_60px_1fr] h-8 border-b border-solid border-red-300 box-border items-center">
                <div className="border-r border-solid border-red-300 px-1  h-full flex justify-center items-center">
                  <div>업태</div>
                </div>
                <div className="border-r border-solid border-red-300 px-1 h-full flex justify-center items-center">
                  <div>{setting.bussinessType}</div>
                </div>
                <div className="border-r border-solid border-red-300 px-1 h-full flex justify-center items-center">
                  <div>종목</div>
                </div>
                <div>{setting.bussinessItem}</div>
              </div>
              <div className="grid grid-cols-[60px_1fr] box-border items-center h-8">
                <div className="border-r border-solid border-red-300 px-1 whitespace-pre-wrap h-8 flex justify-center items-center">
                  <div>이메일</div>
                </div>
                <div className="px-1 h-full flex justify-start items-center pl-3">
                  <div>{setting.email}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="border-solid border-gray-300 grid grid-cols-[30px_1fr] items-stretch border-b-2 border-b-gray-400">
            <div className="text-center font-bold text-blue-600 bg-blue-200 px-2 flex items-center">
              <div>공급받는자</div>
            </div>
            <div className="text-center">
              <div className="grid grid-cols-[60px_1fr_60px_60px] border-b border-solid border-blue-300 box-border items-center">
                <div className="border-r border-solid border-blue-300 px-1 whitespace-pre-wrap">
                  등록{"\n"}번호
                </div>
                <div className="border-r border-solid border-blue-300 px-1 h-full flex justify-center items-center">
                  <div>{vatInvoice.vatCompany?.businessNo ?? ""}</div>
                </div>
                <div className="border-r border-solid border-blue-300 px-1">
                  종사업장 번호
                </div>
                <div></div>
              </div>
              <div className="grid grid-cols-[60px_1fr_60px_60px] border-b border-solid border-blue-300 box-border items-center">
                <div className="border-r border-solid border-blue-300 px-1 whitespace-pre-wrap">
                  상호{"\n"}(법인명)
                </div>
                <div className="border-r border-solid border-blue-300 px-1 h-full flex justify-center items-center">
                  <div>{vatInvoice.vatCompany?.name ?? ""}</div>
                </div>
                <div className="border-r border-solid border-blue-300 px-1 h-full flex justify-center items-center">
                  <div>성명</div>
                </div>
                <div>{vatInvoice.vatCompany?.ceoName ?? ""}</div>
              </div>
              <div className="grid grid-cols-[60px_1fr] border-b border-solid border-blue-300 box-border items-center h-8">
                <div className="border-r border-solid border-blue-300 px-1 whitespace-pre-wrap h-8 flex justify-center items-center">
                  <div>사업장</div>
                </div>
                <div className="px-1 h-full flex justify-start items-center pl-3">
                  <div>{vatInvoice.vatCompany?.address ?? ""}</div>
                </div>
              </div>
              <div className="grid grid-cols-[60px_1fr_60px_1fr] h-8 border-b border-solid border-blue-300 box-border items-center">
                <div className="border-r border-solid border-blue-300 px-1  h-full flex justify-center items-center">
                  <div>업태</div>
                </div>
                <div className="border-r border-solid border-blue-300 px-1 h-full flex justify-center items-center">
                  <div>{vatInvoice.vatCompany?.bussinessType ?? ""}</div>
                </div>
                <div className="border-r border-solid border-blue-300 px-1 h-full flex justify-center items-center">
                  <div>종목</div>
                </div>
                <div>{vatInvoice.vatCompany?.bussinessItem ?? ""}</div>
              </div>
              <div className="grid grid-cols-[60px_1fr] box-border items-center h-8">
                <div className="border-r border-solid border-blue-300 px-1 whitespace-pre-wrap h-8 flex justify-center items-center">
                  <div>이메일</div>
                </div>
                <div className="px-1 h-full flex justify-start items-center pl-3">
                  <div>{vatInvoice.vatCompany?.email ?? ""}</div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
        <div className="border-b-2 border-gray-400 text-sm">
          <div className="grid grid-cols-[1fr_1fr_1fr_2fr] border-b border-solid border-blue-300 bg-indigo-50 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>작성일자</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>공급가액</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>세액</div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div>수정사유</div>
            </div>
          </div>
          <div className="grid grid-cols-[1fr_1fr_1fr_2fr] border-b-2 border-solid border-gray-400 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {dayjs(vatInvoice.issuedDate).toDate().toLocaleDateString() ??
                  ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>{vatInvoice.supplyAmt.toLocaleString()}</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>{vatInvoice.taxAmt.toLocaleString()}</div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div></div>
            </div>
          </div>
          <div className="grid grid-cols-[30px_30px_1fr_60px_60px_60px_140px_140px_40px] border-b border-solid border-gray-300 bg-indigo-50 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>월</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>일</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>품목</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>규격</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>수량</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>단가</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>공급가액</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>세액</div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div>비고</div>
            </div>
          </div>
          <div className="grid grid-cols-[30px_30px_1fr_60px_60px_60px_140px_140px_40px] border-b border-solid border-gray-300 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate1 && vatInvoice.totalAmt1 > 0
                  ? new Date(vatInvoice.supplyDate1).getMonth() + 1
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate1 && vatInvoice.totalAmt1 > 0
                  ? new Date(vatInvoice.supplyDate1).getDate()
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>{vatInvoice.supplyContent1 ?? ""}</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyAmt1 === 0
                  ? ""
                  : vatInvoice.supplyAmt1.toLocaleString()}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.taxAmt1 === 0
                  ? ""
                  : vatInvoice.taxAmt1.toLocaleString()}
              </div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div></div>
            </div>
          </div>
          <div className="grid grid-cols-[30px_30px_1fr_60px_60px_60px_140px_140px_40px] border-b border-solid border-gray-300 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate2 && vatInvoice.totalAmt2 > 0
                  ? new Date(vatInvoice.supplyDate2).getMonth() + 1
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate2 && vatInvoice.totalAmt2 > 0
                  ? new Date(vatInvoice.supplyDate2).getDate()
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>{vatInvoice.supplyContent2 ?? ""}</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyAmt2 === 0
                  ? ""
                  : vatInvoice.supplyAmt2.toLocaleString()}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.taxAmt2 === 0
                  ? ""
                  : vatInvoice.taxAmt2.toLocaleString()}
              </div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div></div>
            </div>
          </div>
          <div className="grid grid-cols-[30px_30px_1fr_60px_60px_60px_140px_140px_40px] border-b border-solid border-gray-300 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate3 && vatInvoice.totalAmt3 > 0
                  ? new Date(vatInvoice.supplyDate3).getMonth() + 1
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate3 && vatInvoice.totalAmt3 > 0
                  ? new Date(vatInvoice.supplyDate3).getDate()
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>{vatInvoice.supplyContent3 ?? ""}</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyAmt3 === 0
                  ? ""
                  : vatInvoice.supplyAmt3.toLocaleString()}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.taxAmt3 === 0
                  ? ""
                  : vatInvoice.taxAmt3.toLocaleString()}
              </div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div></div>
            </div>
          </div>
          <div className="grid grid-cols-[30px_30px_1fr_60px_60px_60px_140px_140px_40px] border-b border-solid border-gray-300 h-8 items-center">
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyDate4 && vatInvoice.totalAmt4 > 0
                  ? new Date(vatInvoice.supplyDate4).getMonth() + 1
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {" "}
                {vatInvoice.supplyDate4 && vatInvoice.totalAmt4 > 0
                  ? new Date(vatInvoice.supplyDate4).getDate()
                  : ""}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>{vatInvoice.supplyContent4 ?? ""}</div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div></div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.supplyAmt4 === 0
                  ? ""
                  : vatInvoice.supplyAmt4.toLocaleString()}
              </div>
            </div>
            <div className="border-r-2 border-solid border-gray-300 h-full flex items-center justify-center">
              <div>
                {vatInvoice.taxAmt4 === 0
                  ? ""
                  : vatInvoice.taxAmt4.toLocaleString()}
              </div>
            </div>
            <div className="h-full flex items-center justify-center">
              <div></div>
            </div>
          </div>
        </div>
        <div className="text-sm grid grid-cols-[2fr_1fr] items-center border-solid border-t-2 border-gray-400 ">
          <div className="">
            <div className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr] bg-blue-50 border-b border-solid border-gray-300">
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div>합계금액</div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div>현금</div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div>수표</div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div>어음</div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div>외상미수금</div>
              </div>
            </div>
            <div className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr]">
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div>
                  <div>{vatInvoice.totalAmt.toLocaleString()}</div>
                </div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div></div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div></div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div></div>
              </div>
              <div className="border-r border-solid border-gray-300 h-8 flex items-center justify-center">
                <div></div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div>이 금액을 청구함</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VatPaper;
